document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('cv-form');
    const submitButton = document.getElementById('submit-button');
    const spinner = document.getElementById('spinner');

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      submitButton.disabled = true;
      spinner.style.display = 'inline-block';

      try {
        const formData = new FormData(form);

        const response = await fetch(form.action, {
          method: form.method,
          body: formData,
        });

        if (response.ok) {
          form.reset();
        } else {
          console.error('Form submission failed. Please try again.');
        }
      } catch (error) {
        console.error('An error occurred:', error);
      }
    });
});